// Pomocnicze operacje na konstrukcji (blueprint).

import type { Connection, PartInstance, RobotBlueprint, SocketRef } from './types';

export function connectionKey(ref: SocketRef): string {
  return `${ref.partId}#${ref.socketId}`;
}

export function socketRefEquals(a: SocketRef, b: SocketRef): boolean {
  return a.partId === b.partId && a.socketId === b.socketId;
}

export function findPart(blueprint: RobotBlueprint, partId: string): PartInstance | undefined {
  return blueprint.parts.find((part) => part.id === partId);
}

export function mustFindPart(blueprint: RobotBlueprint, partId: string): PartInstance {
  const part = findPart(blueprint, partId);
  if (!part) throw new Error(`Nie ma czesci o id "${partId}"`);
  return part;
}

export function cloneBlueprint(blueprint: RobotBlueprint): RobotBlueprint {
  return {
    schemaVersion: blueprint.schemaVersion,
    parts: blueprint.parts.map((part) => ({ ...part })),
    connections: blueprint.connections.map(
      (conn): Connection => ({
        a: { ...conn.a },
        b: { ...conn.b },
      }),
    ),
    drives: blueprint.drives.map((drive) => ({
      drivePartId: drive.drivePartId,
      wheelPartIds: [...drive.wheelPartIds],
    })),
  };
}

export function emptyBlueprint(): RobotBlueprint {
  return { schemaVersion: 2, parts: [], connections: [], drives: [] };
}
